import { Reducer } from "redux";
import {
    SET_TIMESTAMPS,
    TOGGLE_ALL_TIMESTAMPS,
    TOGGLE_TIMESTAMP,
} from "../actions/timestampsActions";
import { ITimestamp } from "../components/TimestampsSelector/timestamps";

export type TimestampsStringDict = { [key: number]: string };
export type TimestampsDict = { [key: number]: number[] };
export type TimestampsDescriptionDict = { [key: string]: string };

export interface TimestampsState {
    //timestamps: number[];
    timestamps: ITimestamp[];
}

const initialState: TimestampsState = {
    timestamps: [],
};

export const timestampsReducer: Reducer<TimestampsState> = (
    state: TimestampsState = initialState,
    action: any
): TimestampsState => {
    switch (action.type) {
        case TOGGLE_TIMESTAMP:
            if (state.timestamps.includes(action.timestamp)) {
                return {
                    ...state,
                    timestamps: state.timestamps
                        //.filter((x: number) => x !== action.timestamp)
                        .filter((x: ITimestamp) => x.key !== action.timestamp.key)
                        .sort((a, b) => a.key - b.key),
                    //.sort((a, b) => a - b),
                };
            } else
                return {
                    ...state,
                    timestamps: state.timestamps.concat(action.timestamp)
                        .sort((a, b) => a.key - b.key),
                    //.sort((a, b) => a - b),
                };
        case TOGGLE_ALL_TIMESTAMPS:
            /*
            if (state.timestamps.length === 24)
            */
            if (state.timestamps.length === action.availableTimestampsOrScenarios.length)
                return {
                    ...state,
                    timestamps: [],
                };
            else
                return {
                    ...state,
                    //timestamps: allTimestamps,
                    timestamps: action.availableTimestampsOrScenarios,
                };
        case SET_TIMESTAMPS:
            return {
                ...state,
                timestamps: action.timestamps,
            };
        default:
            return state;
    }
};
